import { render, staticRenderFns } from "./VsLoader.vue?vue&type=template&id=8dd5beac&scoped=true&"
import script from "./VsLoader.vue?vue&type=script&lang=js&"
export * from "./VsLoader.vue?vue&type=script&lang=js&"
import style0 from "./VsLoader.vue?vue&type=style&index=0&id=8dd5beac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd5beac",
  null
  
)

export default component.exports